<!-- Breadcrumb -->
<div class="pag-container">

  <app-campaign-3-breadcrumb
    #breadcrumbComponent
    *ngIf="showBreadCrumb"
    [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)"
    homeLink="">
  </app-campaign-3-breadcrumb>

  <!-- Bottone Creazione -->
  <div class="ui-g-12 d-flex justify-content-center">
    <div class="ui-g-7"></div>

    <div class="ui-g-5 footer-btn-container">
      <button
        class="btn-page-act"
        data-testid="createNewChallenge"
        (click)="onOpenCreation()">
        <i class="pi pi-plus"></i>
        <span>{{ 'challenge.insert_new_challenge' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- Tabella principale -->
  <div class="ui-g-12 prova">
    <app-campaign-3-kontable
      *ngIf="readyTable"
      #challengeList
      [columns]="[
        { field: 'id', title: 'challenge.id', filterType: textFilter,bodyTemplate: idTemplate },
        { field: 'title', title: 'challenge.title', filterType: textFilter },
        { field: 'dateStart', title: 'challenge.dateStart', type: 'date', filterType: dateFilter, bodyTemplate: dateStartTemplate },
        { field: 'dateEnd', title: 'challenge.dateEnd', type: 'date', filterType: dateFilter, bodyTemplate: dateEndTemplate },
        { field: 'distributionListName', title: 'challenge.targetList', filterType: textFilter },
        { field: 'numLevel', title: 'challenge.numLevel', filterType: textFilter, bodyTemplate: numLevelTemplate },
        { field: 'challengeType', title: 'challenge.challengeKind', filterType: selectFilter, filterOptions: { values: challengeTypes },bodyTemplate: challengeTypeTemplate },
        { field: 'flgAgreementRequired', title: 'challenge.acceptanceRequired', filterType: textFilter, bodyTemplate: flgAgreementRequiredTemplate },
        { field: 'status', title: 'challenge.status', bodyTemplate: statusTemplate, filterType: selectFilter, filterOptions: { values: statusList } }
      ]"
      [service]="challengeService"
      [paginationType]="paginationType"
      [additionalRowCommands]="actions"
      [expandTable]="true"
      [fetchActionListAsap]="false"
      [subjectToLoad]="pageSubject"
      [filterBySingleColumn]="false"
      [showRecoverButton]="false"
      [showInfoButton]="false"
      [showAddButton]="false"
      [showDeleteButton]="false"
      [showDetailsButton]="false"
      [showEditButton]="false"
      [fetchChallengeListAsap]="true"
      [showGlobalFilter]="true"
      [customExpandedRowTemplate]="customTemplate">

      <!-- Template espansione: lista livelli -->
      <ng-template
        #customTemplate
        let-challengeDetailList="challengeDetailList"
        let-challengeDetailListElaborated="challengeDetailListElaborated"
        let-row>
        <ng-container *ngIf="challengeDetailList">
          <app-challenge-levels
            [challengeDetailList]="challengeDetailList"
            [challengeDetailListElaborated]="challengeDetailListElaborated"
            [fatherChallenge]="row"
            (refreshChallengeLevels)="refreshChallengeLevelsViaKontable(row)">
          </app-challenge-levels>
        </ng-container>
      </ng-template>

      <!-- SÌ/NO richiesta accettazione -->
      <ng-template #flgAgreementRequiredTemplate let-row>
        <span class="center-number">
          {{ row.flgAgreementRequired === '1' ? 'Si' : 'No' }}
        </span>
      </ng-template>

      <!-- Numero livelli -->
      <ng-template #numLevelTemplate let-row>
        <span class="center-number">
          {{ row.numLevel }}
        </span>
      </ng-template>

            <!-- Numero livelli -->
      <ng-template #idTemplate let-row>
        <span class="center-number">
          {{ row.id }}
        </span>
      </ng-template>


              <!-- Numero livelli -->
      <ng-template #challengeTypeTemplate let-row>
        <span >
          {{ row.challengeTypeDescription }}
        </span>
      </ng-template>

      <!-- Stato challenge -->
      <ng-template #statusTemplate let-row>
        <span class="center-number">
          <span class="status-dot" [ngClass]="statusColors[row.status] || 'green-dot'"></span>
          {{ statusLabels[row.status] || statusLabels.default }}
        </span>
      </ng-template>

      <!-- Date -->
      <ng-template #dateStartTemplate let-row>
        <span class="center-number">
          {{ row.dateStart | date:srvCalendar.pcalendarTranslate.dateFormatFilter }}
        </span>
      </ng-template>

      <ng-template #dateEndTemplate let-row>
        <span class="center-number">
          {{ row.dateEnd | date:srvCalendar.pcalendarTranslate.dateFormatFilter }}
        </span>
      </ng-template>

      <!-- Azioni riga -->
      <ng-template #actions let-row>

        <div class="d-flex justify-content-center">
          <button
            class="roundedButton row-buttom-margin"
            pTooltip="{{ 'common.edit' | translate }}"
            data-testid-generic="editChallenge"
            [attr.data-testid]="'editChallenge' + row.id"
            (click)="onOpenEdit(row)"
            [disabled]="!isRowEditable(row)"
            [ngClass]="{ 'disabled-button': !isRowEditable(row) }">
            <i class="pi pi-pencil icon-size"></i>
          </button>

          <button
            class="roundedButton"
            pTooltip="{{ 'common.actions' | translate }}"
            data-testid-generic="challengeActions"
            [attr.data-testid]="'challengeActions' + row.id"
            (click)="toggleMenu(row)">
            <i class="pi pi-ellipsis-h icon-size"></i>
          </button>
        </div>

        <!-- Dropdown azioni -->
        <div
          class="dropdown-menu"
          *ngIf="showMenu && row.id == currentOpenedRow">

        
          <button
            class="dropdown-item-creation"
            data-testid-generic="deleteChallenge"
            [disabled]="isAlreadyDeleted(row)"
            (click)="deleteChallenge(row)"
            [ngClass]="{ 'notPermitted': isAlreadyDeleted(row) }">
            {{ 'common.delete' | translate }}
          </button>

          <!-- publish -->
             <button
            class="dropdown-item-creation"
            data-testid-generic="publishChallenge"
            [disabled]="!canPublish(row)"
            (click)="publishChallenge(row)"
             [ngClass]="{ 'notPermitted': !canPublish(row) }">
            {{ 'challenge.publish' | translate }}
          </button>
          <!-- unpublish -->
              <button
            class="dropdown-item-creation"
            data-testid-generic="unPublishChallenge"
            [disabled]="!canUnpublish(row)"
            (click)="unpublishChallenge(row)"
            [ngClass]="{ 'notPermitted': !canUnpublish(row) }">
            {{ 'challenge.unpublish' | translate }}
          </button>


             <button 
            data-testid-generic="viewNotificationStatus" class="dropdown-item-creation"
            (click)="openNotificationStatus(row)">
            {{ 'common.view_status' | translate }}
          </button>

        </div>

      </ng-template>

    </app-campaign-3-kontable>
  </div>
</div>

<!-- Popup cancellazione -->
<p-dialog
  class="custom-dialog"
  header="{{ 'challenge.confirm_delete' | translate }}"
  [(visible)]="displayDeleteDialog"
  [modal]="true"
  [closable]="false">

  <div>
    {{ 'challenge.confirm_delete_message' | translate }}
  </div>

  <div class="custom-footer">
    <button
      type="button"
      pButton
      icon="pi pi-times"
      label="{{ 'common.cancel' | translate }}"
      (click)="closePopupDelete()">
    </button>

    <button
      type="button"
      pButton
      icon="pi pi-check"
      label="{{ 'common.confirm' | translate }}"
      style="margin-left: .25em"
      (click)="onDefinitiveDelete(challengeToDelete)">
    </button>
  </div>

</p-dialog>
<!-- popup notifiation -->

<p-dialog 
    *ngIf="showNotificationStatusModal" 
    [(visible)]="showNotificationStatusModal" 
    [modal]="true"
    [responsive]="true" 
    [width]="800" 
    [header]="'notification.status_detail' | translate" 
    showEffect="fade"
    (onHide)="closeNotificationStatusModal()">

    <div *ngIf="isLoadingNotification" class="text-center p-4">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    </div>

    <app-notification-popup-menu
        *ngIf="!isLoadingNotification"
        [row]="selectedNotificationRow"
        [visible]="showNotificationStatusModal"
        [isDetailedView]="true"
        (onClose)="closeNotificationStatusModal()">
    </app-notification-popup-menu>

</p-dialog>



<!-- Popup pubblicazione -->
<p-dialog
  class="custom-dialog"
  header="{{ 'challenge.publish' | translate }}"
  [(visible)]="showPopupPublish"
  [modal]="true"
  [closable]="false">

  <div>
    {{ 'challenge.publish_warning' | translate }}
    <!-- Attenzione, la sfida non sarà più modificabile -->
  </div>

  <div class="custom-footer">

    <button
      type="button"
      pButton
      icon="pi pi-times"
      label="{{ 'common.cancel' | translate }}"
      (click)="undoPublishChallenge()">
    </button>

    <button
      type="button"
      pButton
      icon="pi pi-check"
      label="{{ 'common.confirm' | translate }}"
      style="margin-left: .25em"
      (click)="confirmPublish()"> 
      <!-- crea le regole e setta sola lettura -->
    </button>

  </div>
</p-dialog>



<!-- Popup annulla pubblicazione -->    
<p-dialog
  class="custom-dialog"
  header="{{ 'challenge.unpublish' | translate }}"
  [(visible)]="showPopupUnpublish"
  [modal]="true"
  [closable]="false">

  <div>
    {{ 'challenge.unpublish_warning' | translate }}
    <!-- Attenzione, stai annullando una sfida che i clienti potrebbero aver già visualizzato o ricevuto notifiche push -->
  </div>

  <div class="custom-footer">

    <button
      type="button"
      pButton
      icon="pi pi-times"
      label="{{ 'common.cancel' | translate }}"
      (click)="undoUnpublishChallenge()">
    </button>

    <button
      type="button"
      pButton
      icon="pi pi-check"
      label="{{ 'common.confirm' | translate }}"
      style="margin-left: .25em"
      (click)="confirmUnpublish()">
    </button>

  </div>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-list/challenge-list.component.html